import * as angular from "angular";
import * as _ from "lodash";
import { fileConstants } from "../utils/constants/files.constants";

export class CustomFieldAttachmentModel {
    public cfoid: number;
    public hocfid: number;
    public name: string;
    public data: any;
    public iconName: string;
    public fileType: string;
    public fileNameOnly: string;
    public extension: string;
    public url: string;
    public status: string;

    constructor(data?: any) {
        this.setData(data);
    }

    setData(data: object): void {
        _.merge(this, data);
        this.extension = this.getFileExtension();
        this.fileType = this.getFileType();
        this.iconName = this.getIconName();
        this.fileNameOnly = this.getFileNameWithoutExtension();
    }

    getFileExtension(): string | null {
        if (this.name) {
            const splits: string[] = this.name.split(".");
            return splits[splits.length - 1].toLowerCase();
        }
        return null;
    }

    getFileNameWithoutExtension(): string | null {
        if (this.name) {
            return this.name.split(".").slice(0, -1).join(".");
        }
        return null;
    }

    getFileType(): string {
        let foundCategory = null;
        angular.forEach(
            fileConstants.categories,
            (items: string[], name: string) => {
                if (items.includes(this.extension)) {
                    foundCategory = name;
                }
            }
        );
        return foundCategory ?? "other";
    }

    getIconName(): string {
        if (this.fileType == "image") {
            return "image";
        } else if (this.fileType == "pdf") {
            return "picture_as_pdf";
        } else if (this.fileType == "csv") {
            return "csv";
        } else if (this.fileType == "spreadsheet") {
            return "table_chart";
        } else if (this.fileType == "archive") {
            return "folder_zip";
        } else if (this.fileType == "audio") {
            return "audio_file";
        } else if (this.fileType == "video") {
            return "video_file";
        } else if (this.fileType == "text" || this.fileType == "document") {
            return "description";
        }
        return "attach_file";
    }
}
